import React, { useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { cleanMask, cnpjMask, cpfMask } from 'masks-br';

import { fetchApi } from '../../services/api';
import {
  EnumAuthContext,
  IHandleAuth,
  signIn,
} from '../../store/modules/auth/actions';
import { chooseTypeFromContext } from '../../utils/Login';

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [otaRequired, setOtaRequired] = useState(false);

  async function handleLogin(info: any) {
    setLoading(true);

    const data: IHandleAuth | undefined = await fetchApi({
      url: '/auth/login',
      method: 'post',
      data: {
        password: info.password,
        document: cleanMask(info.username),
        context: EnumAuthContext.BACKOFFICE,
        otp: info.otp,
      },
      messages: {
        loading: 'Autenticando usuário, aguarde...',
        success: 'Usuário autenticado com sucesso!',
        error: 'Aconteceu um problema aqui, tente novamente!',
      },
      onSuccess: (response) => {
        return response as IHandleAuth;
      },
      onError: error => {
        // @ts-ignore
        if (!otaRequired) setOtaRequired(error?.code === 'auth.otp_required');
      },
    });

    setLoading(false);

    if (!data) return;

    dispatch(
      signIn({
        authenticated: data.logged_as === EnumAuthContext.BACKOFFICE,
        perfis: data.profiles?.map(profile => { return { id_perfil: profile.id_profile, nome: profile.name }}),
        token: data.token,
        usuario: {
          email: data.user.email,
          nome: data.user.name,
          id_usuario: data.user.id_user,
          id_estabelecimento: undefined,
          id_estabelecimento_whitelabel: undefined,
          id_estado: undefined,
        },
        responsabilidades: undefined,
        tipo: chooseTypeFromContext(data.logged_as),
        permissoes: data?.permissions?.map(permission => { return  {id_permissao_perfil: permission.id_permission_profile, nome: permission.name, permissao_correlacao: permission.permission_correlation } }),
        tipo_liquidacao: undefined,
        documento_conta: undefined,
      }),
    );
  }

  function handleUpdateField(doc: string, modali = false) {
    let username = cleanMask(doc);

    if (username.length <= 11) {
      username = cpfMask(doc);
    } else {
      username = cnpjMask(doc);
    }

    if (modali) {
      formModal.setFieldsValue({ username });
      return;
    }

    form.setFieldsValue({ username });
  }

  function handleSubmitForgotPassword({ documento }: any) {
    return fetchApi({
      url: `/account-recovery`,
      method: 'post',
      messages: {
        error:
          'Não conseguimos concluir o envio do email, entre em contato conosco!',
        loading: 'Enviando email de recuperação de senha, aguarde!',
      },
      data: {
        document: cleanMask(documento),
      },
      onSuccess: () => {
        setModal(false);
        formModal.resetFields();
        Modal.success({
          title: 'Sucesso',
          content: 'Enviamos em seu email um link para alterar sua senha!',
          centered: true,
        });
      },
    });
  }

  return (
    <>
      <h1>Login</h1>

      <Form layout="vertical" onFinish={handleLogin} form={form}>
        <Form.Item
          label="CPF ou CNPJ"
          name="username"
          rules={[{ required: true, message: 'Favor inserir seu documento!' }]}
        >
          <Input onChange={val => handleUpdateField(val.target.value)} />
        </Form.Item>

        <Form.Item
          label="Senha"
          name="password"
          rules={[{ required: true, message: 'Favor inserir sua senha!' }]}
        >
          <Input.Password />
        </Form.Item>

        {otaRequired ? (
          <Form.Item
            label="Token"
            name="otp"
            rules={[
              { required: true, message: 'Insira o token de autenticação' },
            ]}
          >
            <Input.Password />
          </Form.Item>
        ) : null}

        <span onClick={() => setModal(true)} style={{ cursor: 'pointer' }}>
          Esqueceu sua senha?
        </span>
        <br />
        <br />

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Entrar
          </Button>
        </Form.Item>
      </Form>

      <Modal
        title="Esqueci minha senha"
        centered
        visible={modal}
        footer={false}
        onCancel={() => setModal(false)}
      >
        <Form
          form={formModal}
          layout="vertical"
          onFinish={data => handleSubmitForgotPassword(data)}
        >
          <Form.Item label="CPF ou CNPJ" name="documento">
            <Input
              onChange={val => handleUpdateField(val.target.value, true)}
            />
          </Form.Item>

          <br />

          <Button type="primary" htmlType="submit">
            Enviar Email
          </Button>
        </Form>
      </Modal>
    </>
  );
};

export default Login;
